import { api } from './client'

// MOCK-ONLY API — the booking calendar. The real backend has no appointments;
// the real counterpart is the GHL calendar. Wire types live here until then.

export type AppointmentKind = 'inspection' | 'dropoff'

export interface ShopAppointment {
  id: number
  teamId: number
  estimateId: number | null
  customerId: number | null
  customerName: string
  customerPhone: string | null
  vehicleLabel: string | null
  estimateValue: number | null
  kind: AppointmentKind
  startsAt: string
  durationMinutes: number
  source: 'link' | 'shop'
  /** Set after the slot passes: did the customer actually show up? */
  outcome: 'attended' | 'no_show' | null
  createdAt: string
  updatedAt: string
}

export interface SlotInfo {
  startsAt: string
  capacity: number
  booked: number
  free: number
}

export interface BookingLinkInfo {
  token: string
  shop: { name: string; phone: string | null; initials: string }
  customerName: string
  vehicleLabel: string | null
  estimateValue: number | null
  state: 'open' | 'booked' | 'expired'
  appointment: ShopAppointment | null
  options: { inspectionEnabled: boolean; dropoffEnabled: boolean; slotMinutes: number }
}

export const appointmentsApi = {
  listByTeam: (teamId: number | string, from: string, to: string) =>
    api.get<ShopAppointment[]>(`/appointments/team/${teamId}`, { from, to }),
  slots: (teamId: number | string, from: string, to: string) =>
    api.get<SlotInfo[]>(`/appointments/team/${teamId}/slots`, { from, to }),
  create: (data: {
    teamId: number
    estimateId?: number | null
    kind: AppointmentKind
    startsAt: string
    customerName?: string
    customerPhone?: string
    vehicleLabel?: string
  }) => api.post<ShopAppointment>('/appointments', data),
  reschedule: (id: number, startsAt: string) =>
    api.patch<ShopAppointment>(`/appointments/${id}`, { startsAt }),
  setOutcome: (id: number, outcome: 'attended' | 'no_show') =>
    api.patch<ShopAppointment>(`/appointments/${id}`, { outcome }),
  cancel: (id: number) => api.delete<void>(`/appointments/${id}`),
}

// The customer's side — public, tokened; works with no auth header.
export const bookingApi = {
  info: (token: string) => api.get<BookingLinkInfo>(`/booking/${token}`),
  slots: (token: string, from: string, to: string) =>
    api.get<SlotInfo[]>(`/booking/${token}/slots`, { from, to }),
  confirm: (token: string, startsAt: string, kind: AppointmentKind) =>
    api.post<ShopAppointment>(`/booking/${token}/confirm`, { startsAt, kind }),
  cancel: (token: string) => api.post<void>(`/booking/${token}/cancel`, {}),
}
